import { filter_day, filter_month, filter_week } from '../../../../../views/marketing/overview/PeriodFilter';

export default {
  filters: {
    [filter_day]: 'Dia',
    [filter_week]: 'Semana',
    [filter_month]: 'Mês',
    null: 'Total',
  },
};
